const { instance } = require('./url')

async function queryEnvironment(query) {
    const response = await instance.post('/environment/query', query)
    return response.data
}

export {
  queryEnvironment,
}

